import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

export default function LinearProgressBar() {
  return (
    <Box sx={{ width: "100%", color: "grey.500" }}>
      <LinearProgress color="secondary" />
    </Box>
  );
}
